<template>
  <v-app class="app-tabela">
    <div class="info-table py-4">
      <div class="info-table-item">
        <vue-select
          :options="vacinas"
          label="label"
          placeholder="Indicador"
          v-model="vacina"
          @input="filterIndicator($event)"
          :clearable="true"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <v-card class="tabela">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="input-bottom"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @pagination="getPagination"
        :page="currentPage"
        :footer-props="{
          itemsPerPageText: '',
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        :loading="loading"
        loading-text="Carregando, Por favor espere"
        :headers="headers"
        :items="indexedItems"
        :search="search"
        item-key="index"
        class="elevation-1"
        :item-class="getRowColor"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:item.dt_aplicacao="{ item }">
          <td>
            {{ item.dt_aplicacao != null ? formatDate(item.dt_aplicacao) : '' }}
          </td>
        </template>

        <template v-slot:item.dt_nascimento="{ item }">
          <td>
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
          </td>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td colspan="9">
            <table class="table table-interna table-interna-acompanhamento">
              <thead>
                <tr>
                  <th>CFCP</th>
                  <th>CPF</th>
                  <th>CNS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.cfcp }}</td>
                  <td>{{ item.cpf }}</td>
                  <td>{{ item.cns }}</td>
                </tr>
              </tbody>
            </table>

            <b-alert
              v-if="item.dt_nascimento != cidadao.dt_nascimento"
              variant="danger"
              show
              class="mt-4"
            >
              A data de nascimento registrada nesse atendimento
              {{
                item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
              }}
              é diferente da data de nascimento atual do cidadão
              {{
                cidadao.dt_nascimento != null
                  ? formatDate(cidadao.dt_nascimento)
                  : ''
              }}.
            </b-alert>

            <b-alert
              v-if="cidadao.sexo.toUpperCase() != item.ds_sexo.toUpperCase()"
              variant="danger"
              show
            >
              O sexo informado no atendimento do dia
              {{ formatDate(item.dt_atendimento) }} é diferente do sexo
              informado no cadastro atual.
            </b-alert>
          </td>
        </template>

        <template v-slot:[`footer.page-text`]="items">
          <div class="info-table-item tabela-esus-pec">
            <FonteSincronizadorC />
          </div>
          <span class="paginacao"
            >{{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }} registros</span
          >
        </template>

        <template v-slot:no-data>
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
        <template v-slot:no-results style="padding: 0px">
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Vacinas',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
    cnsList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'IMUNO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'no_imuno',
        },
        {
          text: 'DOSE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'no_dose_imuno',
        },
        {
          text: 'APLICAÇÃO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_aplicacao',
        },
        {
          text: 'NASCIMENTO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'SEXO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'ds_sexo',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastrosOriginais: [],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
      vacinas: [
        {
          label: 'Penta e Vip',
          value: '',
          searchValues: ['Poliomielite inativada', 'DTP / HB / Hib'],
        },
      ],
      vacina: null,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      if (this.cidadao.dt_nascimento != item.dt_nascimento) {
        return 'table-row-color-red'
      }

      if (this.cidadao.sexo.toUpperCase() != item.ds_sexo.toUpperCase()) {
        return 'table-row-color-red'
      }

      return ''
    },

    /**
     * Filtra os cadastros pelo indicador informado.
     * @param {Object|null} indicador Indicador selecionado
     */
    filterIndicator(indicador) {
      if (indicador == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }

      this.cadastros = this.cadastrosOriginais.filter((item) => {
        return indicador.searchValues.some((value) =>
          item.no_imuno.includes(value)
        )
      })
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true

        let cnsListParam = this.cnsList.join(',')

        const response2 = await this.$api.get(
          `/app/acs-por-cidadao/${this.$store.state.cod_ibge}/${this.cidadao.nu_cpf}/${cnsListParam}/vacinas`
        )
        if (response2) {
          this.cadastrosOriginais = response2.data
          this.cadastros = response2.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
